import TypesenseError from "./TypesenseError";

export default class RequestMalformed extends TypesenseError {}
